import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row gap-x-4 mt-4"
}
const _hoisted_2 = { class: "w-6/20" }
const _hoisted_3 = { class: "text-14px font-semibold w-full px-4 py-3" }
const _hoisted_4 = { class: "w-14/20" }
const _hoisted_5 = {
  class: "w-full px-4 py-3 rounded-t-md",
  style: {"background":"#f5f5f5"}
}
const _hoisted_6 = { class: "text-14px font-semibold" }
const _hoisted_7 = { class: "h-full px-4 py-3" }
const _hoisted_8 = { class: "text-14px font-normal text-gray-lp-300 text-justify" }
const _hoisted_9 = {
  key: 1,
  class: "text-14px font-normal text-gray-lp-300"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Card = _resolveComponent("Card")!
  const _component_PreviewImage = _resolveComponent("PreviewImage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_Title, {
          label: _ctx.$t('dexAssessment.consoleDisputeInformation')
        }, null, 8, ["label"]),
        (
        !!_ctx.data.daProofPhotoDisputePartner?.length && !!_ctx.data.daRemarksPartner
      )
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_Card, {
                  class: "w-full",
                  style: {"min-height":"350px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("dexAssessment.dexPhoto")), 1),
                    _createVNode("img", {
                      src: _ctx.data.daProofPhotoDisputePartner[0],
                      class: "w-full rounded-b-md cursor-pointer",
                      alt: "dex-photo",
                      style: {"height":"310px"},
                      onClick: _cache[1] || (_cache[1] = () => _ctx.actionModalPreview(true))
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_Card, { style: {"min-height":"350px"} }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("dexAssessment.notesFromConsole")), 1)
                    ]),
                    _createVNode("div", _hoisted_7, [
                      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.data.daRemarksPartner), 1)
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_9, " - "))
      ]),
      _: 1
    }),
    (_ctx.showPreviewImage)
      ? (_openBlock(), _createBlock(_component_PreviewImage, {
          key: 0,
          onClose: () => _ctx.actionModalPreview(false),
          data: _ctx.data.daProofPhotoDisputePartner
        }, null, 8, ["onClose", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}